import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import configureStore from './redux/configureStore';
import {
  Auth,
  CRM,
  CMMS,
  HRMS,
  FMS,
  IMS,
  Information,
  Account,
  TMS,
  JMS,
  WMS,
  BMS,
  BMMS,
  MECH,
  DASHBOARD,
} from './layouts';
import Home from './views/Home';
import PrivateRoute from './contexts/PrivateRoute';
import AuthProvider from './contexts/AuthContext';
import theme from './theme';

import app from './configs/firebase';
import { getMessaging, onMessage } from 'firebase/messaging';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/styles/index.css';

const store = configureStore();
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

const messaging = getMessaging(app);

onMessage(messaging, (payload) => {
  const { prefix, nomachine, time, cause, name, detail } = payload.data;

  const limitText = (text, maxLength = 100) => {
    if (!text) return '-';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  toast(
    <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
      <div style={{ fontWeight: 'bold', color: '#d32f2f', fontSize: '16px' }}>
        {prefix}{payload.notification.title}
      </div>
      <div>รหัสเครื่องจักร: <strong>{nomachine}</strong></div>
      <div>เวลา: <strong>{time}</strong></div>
      <div>สาเหตุ: <em>{limitText(cause)}</em></div>
      <div>ผู้แจ้ง: <u>{name}</u></div>
      <div style={{ marginTop: '8px' }}>
        <button
          onClick={() => window.open(`/cmms/maintenance-orders/detail/${detail}`, '_blank')}
          style={{
            padding: '6px 12px',
            backgroundColor: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px',
          }}
        >
          🔍 ดูรายละเอียด
        </button>
      </div>
    </div>
  );
});

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <div className="bg-gray-100">
          <ToastContainer />
            <Switch>
              <Route path="/auth" component={Auth} />
              <PrivateRoute>
                <Route exact path="/" component={Home} />
                <Route path="/dashboard" component={DASHBOARD} />
                <Route path="/auth" component={Auth} />
                <Route path="/crm" component={CRM} />
                <Route path="/cmms" component={CMMS} />
                <Route path="/hrms" component={HRMS} />
                <Route path="/fms" component={FMS} />
                <Route path="/ims" component={IMS} />
                <Route path="/tms" component={TMS} />
                <Route path="/jms" component={JMS} />
                <Route path="/wms" component={WMS} />
                <Route path="/bms" component={BMS} />
                <Route path="/bmms" component={BMMS} />
                <Route path="/mech" component={MECH} />
                <Route path="/information" component={Information} />
                <Route path="/account" component={Account} />
              </PrivateRoute>
              <Redirect from="*" to="/auth" />
            </Switch>
          </div>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  </Router>,
  document.getElementById('root'),
);
